module.exports = __webpack_public_path__ + "static/WEDDING E&M-551-cdfe932e50c6c63e92f05dcb507a259e.jpg";